import React, { Component } from 'react';

import { Paper, IconButton, Typography } from 'material-ui';

import DemoAnimatedIcon from './DemoAnimatedIcon';

import PauseIcon from 'material-ui-icons/Pause';
import PlayArrowIcon from 'material-ui-icons/PlayArrow';

import { Accent, Primary } from '../helper/consts';

const style = {
	demoSection: {
		margin: '100px auto',
		height: 'min-content'
	},
	infoCard: {
		borderRadius: '20px',
		margin: '170px auto 150px',
		display: 'flex',
		flexDirection: 'column',
		minWidth: '310px',
		overflow: 'hidden',
		position: 'relative',
		maxWidth: '1180px'
	},
	infoCardTitle: {
		color: `${Accent}`,
		padding: '0 0 5px 0px',
		lineHeight: '30px',
		fontSize: '25px'
	},
	infoCardMessage: {
		color: `${Primary}`,
		padding: '25px 0'
	},
	instructions: {
		display: 'flex',
		width: '100%',
		boxSizing: 'border-box'
	},
	demoCardcontainer: {
		width: '100%',
		opacity: '1',
		flexShrink: '0',
		padding: '0 2.5%'
	},
	pausedDemoCardContainer: {
		animationPlayState: 'paused'
	},
	demoControl: {
		position: 'absolute',
		right: '10px',
		top: '10px',
		zIndex: '2'
	}
};

export default class LandingPageDemo extends Component {
	constructor(props) {
		super(props);

		this.state = {
			playing: true
		};
	}
	render() {
		return (
			<section style={style.demoSection}>
				<Paper
					className="landingPageDemoCard"
					style={style.infoCard}
					elevation={20}
				>
					<IconButton
						onClick={() => {
							this.setState({ playing: !this.state.playing });
						}}
						style={style.demoControl}
						aria-label={this.state.playing ? 'Pause' : 'Play'}
						color="primary"
					>
						{this.state.playing ? <PauseIcon /> : <PlayArrowIcon />}
					</IconButton>
					<DemoAnimatedIcon icon="cloud_done" />
					<div style={style.instructions}>
						<div
							style={
								this.state.playing
									? style.demoCardcontainer
									: {
											...style.demoCardcontainer,
											...style.pausedDemoCardContainer
									  }
							}
							className="demoCardcontainer"
						>
							<Typography
								style={style.infoCardTitle}
								type="display1"
								component="h3"
							>
								1. Create Your Position Recruiting Post
							</Typography>
							<Typography style={style.infoCardMessage} type="subheading">
								Quickly and easily create a recruitment post highlighting the
								key talents and traits that you would like to see in an ideal
								candidate. Many people are going to read this so make sure to
								emphasize key skills and focus on the main attributes.
							</Typography>
						</div>
						<div
							style={
								this.state.playing
									? style.demoCardcontainer
									: {
											...style.demoCardcontainer,
											...style.pausedDemoCardContainer
									  }
							}
							className="demoCardcontainer"
						>
							<Typography
								style={style.infoCardTitle}
								type="display1"
								component="h3"
							>
								2. Share Widely
							</Typography>
							<Typography style={style.infoCardMessage} type="subheading">
								Network recruitment leverages the fact that your ideal candidate
								is likely just 2 connections away. Once your networks' network
								starts unearthing their suggested candidates, you'll surely
								identify your ideal candidate.
							</Typography>
						</div>
						<div
							style={
								this.state.playing
									? style.demoCardcontainer
									: {
											...style.demoCardcontainer,
											...style.pausedDemoCardContainer
									  }
							}
							className="demoCardcontainer"
						>
							<Typography
								style={style.infoCardTitle}
								type="display1"
								component="h3"
							>
								3. Meet and Select Ideal Candidates
							</Typography>
							<Typography style={style.infoCardMessage} type="subheading">
								Select from a screened and carefully vetted list qualified
								applicants that are perfect for the role and select finalists
								for a the next step.
							</Typography>
						</div>
					</div>
				</Paper>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/LandingPageDemo.js